import { render, staticRenderFns } from "./payment-mobile.vue?vue&type=template&id=c100513c&lang=pug&"
import script from "./payment-mobile.vue?vue&type=script&lang=js&"
export * from "./payment-mobile.vue?vue&type=script&lang=js&"
import style0 from "./payment-mobile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports